<script lang="ts">
	import './layout.css';

	let { children } = $props();
</script>

{@render children()}
